import classNames from "classnames";
import React, { ReactElement } from "react";

export interface AppBoxActionCardProps {
  icon: JSX.Element;
  label: string;
  className?: string;
  selected?: boolean;
  onClick: () => void;
}

export function AppBoxActionCard(props: AppBoxActionCardProps): ReactElement {
  return (
    <div
      onClick={props.onClick}
      className={classNames("AppBoxActionCard", props.className, {
        Selected: props.selected,
      })}
    >
      <div className="AppBoxActionCard_Icon">{props.icon}</div>
      <div className="AppBoxActionCard_Label">{props.label}</div>
    </div>
  );
}
